/*
 *@Description: 车辆布控路由
 *@Author: zhengff
 *@Date: 2019-04-26 20:18:43
 */
const routes = [
  {
    path: '/carPatrol',
    name: 'carPatrol',
    component: () => import('./view/Home'),
    redirect: '/carPatrol/index',
    meta: {
      requireAuth: true,
    },
    children: [
      {
        path: 'index',
        name: 'carPatrolIndex',
        component: () => import('./view/Index'),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'create',
        name: 'create',
        component: () => import('./view/Create'),
        meta: {
          requireAuth: true,
        },
      },
      {
        path: 'edit',
        name: 'edit',
        component: () => import('./view/Edit'),
        meta: {
          requireAuth: true,
        },
      },
    ],
  },
  {
    path: 'detail',
    name: 'detail',
    component: () => import('./view/Details'),
  },
]

export default routes
